import { useCallback } from 'react';
import type { Filter } from '@vivport/backend/types';
import { useSearchStore } from '@/store/searchStore.ts';

/**
 * The one way a saved filter becomes the active Explore view: activate it in the
 * search store, seed the query from its definition, and reset the input. Used by
 * the sidebar Filter dropdown, landing-view application, and token-less filter
 * tabs (member filters promoted to tabs have no `tab:` shortName token).
 */
export function useApplySavedFilter() {
  const setActiveSavedFilter = useSearchStore((state) => state.setActiveSavedFilter);
  const setQuery = useSearchStore((state) => state.setQuery);
  const resetInputValue = useSearchStore((state) => state.resetInputValue);

  return useCallback(
    (filter: Filter, navigate: (path: string) => void, routePath?: string) => {
      setActiveSavedFilter(filter.id, filter.definition, filter.name);
      const search = filter.definition.search ?? '';
      setQuery(search);
      resetInputValue(navigate, routePath, search);
    },
    [setActiveSavedFilter, setQuery, resetInputValue],
  );
}
